/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

import "./global/global.css";
import Header from "./global/components/Header";
import Larrow from "./assets/Larrow.png";
import BellIcon from "./assets/bellIcon.png";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PlanCards from "./global/components/PlanCards";
import SideBar from "./global/components/SideBar";
import useWindowSize from "./global/hooks/WindowResizer";
import MobileViewHeader from "./global/components/MobileViewHeader";

const AUTH_MODEL_NONE = 1;
const AUTH_MODEL_STAFF = 2;
const AUTH_MODEL_FREE_DEMO = 3;
const AUTH_MODEL_SUBSCRIBER = 4;

const mapStateToProps = (state) => ({
  token: state.token,
});

const MyAccount = (props) => {
  const history = useHistory();
  const [myAccountData, setMyAccountData] = useState(null);
  const [token, setToken] = useState(null || props.token);
  const [error, setError] = useState(null);
  const [stripeError, setStripeError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [apiVersion, setApiVersion] = useState("");

  const isMobileView = useWindowSize();
  const location = useLocation();

  if (!props.token || token === null) {
    history.push("./");
  }

  const handleUpgradeClick = () => {
    console.log("handleUpgradeClick - getting stripe url");
    fetch(`${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/stripe_checkout`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setStripeError(false);
          console.log(result.checkout_url);
          window.location.href = result.checkout_url;
        },
        (error) => {
          setIsLoaded(false);
          setStripeError(error);
          // history.push("./");
        }
      );
  };

  const handleManagePlanClick = (isStaff) => {
    if (!isStaff) {
      console.log("handleManagePlanClick -- todo");
      fetch(`${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/stripe_portal`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        // .then(res => {
        //     if(res.status === 401) {history.push("/");}
        //   })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result && result.portal_url) {
              setStripeError(false);
              console.log(result.portal_url);
              window.location.href = result.portal_url;
            }
          },
          (error) => {
            console.log(error);
            setStripeError(true);
          }
        );
    } else {
      console.log("handleManagePlanClick -- staff so no-op");
    }
  };

  const handleStripeErrorModalClose = () => {
    setStripeError(false);
    // dispatch(clearDashboardError());
  };

  function capitalizeNames(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  useEffect(async () => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/myaccount`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((res) => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setMyAccountData(result);
          },
          (error) => {
            setIsLoaded(false);
            setError(error);
            history.push("./");
          }
        );
    } catch (error) {
      setIsLoaded(false);
      setError(error);
      history.push("./");
    }
  }, []);

  useEffect(async () => {
    const result = await fetch(
      `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/version`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        setApiVersion(result.app_version);
      });
  }, []);

  const [isDetailsPage, setIsDetailsPage] = useState(true);

  const handleMyDetailsPage = () => {
    setIsDetailsPage(true);
  };

  const handleMyPlansPage = () => {
    setIsDetailsPage(false);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (
    !isLoaded ||
    !myAccountData ||
    !myAccountData.accounts ||
    myAccountData.accounts.length === 0 ||
    !myAccountData.accounts.accountInfo
  ) {
    // return <div>Loading...</div>;
    return (
      <div className="myAcc-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="myAccount-root">
          <div className="myAccount-content-container">
            {/* {!isMobileView && (
              <div className="backAndSave">
                <img src={Larrow} alt="backBtn" className="backArrow" />
              </div>
            )} */}

            {/* {isMobileView && <MobileViewHeader />} */}
          </div>

          <h1 style={{ color: "black" }} className="loading">
            Loading...
          </h1>
        </div>
      </div>
    );
  } else {
    const { accountInfo } = myAccountData.accounts;
    const displayname =
      accountInfo[0] && accountInfo[0].name.trim().length > 0
        ? capitalizeNames(accountInfo[0].name) + "'s"
        : "My";
    const authLevel = accountInfo[0] && accountInfo[0].auth_model;
    const isStaff =
      accountInfo[0] && accountInfo[0].auth_model === AUTH_MODEL_STAFF;
    const freeReportsRemaining = accountInfo[0] && accountInfo[0].free_reports;

    return (
      <div className="myAcc-root">
        {/* {!isMobileView && <SideBar />} */}
        <div className="myAccount-root">
          <div className="myAccount-content-container">
            {/* {!isMobileView && (
              <div className="backAndSave">
                <img src={Larrow} alt="backBtn" className="backArrow" />
              </div>
            )}

            {isMobileView && <MobileViewHeader />} */}

            <div className="profile-name">
              <h1 className="name">{displayname}</h1>
              <p className="welcome">Welcome to your profile</p>
            </div>

            <div className="pageBar">
              <p
                className={`pb ${
                  isDetailsPage ? "myDetails activeTab" : "myDetails"
                }`}
                onClick={handleMyDetailsPage}
              >
                My Details
              </p>
              <p
                className={`pb ${
                  !isDetailsPage ? "myPlan activeTab" : "myPlan"
                }`}
                onClick={handleMyPlansPage}
              >
                My Plan
              </p>
            </div>

            {isDetailsPage && (
              <>
                <div className="myDetails-page">
                  <div className="detail-box">
                    <label>Full Name</label>
                    <input
                      type="text"
                      placeholder={capitalizeNames(accountInfo[0].name)}
                      className="profileInputBox"
                      disabled={true}
                      style={{ backgroundColor: "white" }}
                    />
                  </div>
                  <div className="detail-box">
                    <label>Email address</label>
                    <input
                      type="text"
                      placeholder={accountInfo[0].email}
                      className="profileInputBox"
                      disabled={true}
                      style={{ backgroundColor: "white" }}
                    />
                  </div>
                </div>

                <div className="myDetails-page">
                  <div className="detail-box">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      className="profileInputBox"
                      disabled={true}
                      style={{ backgroundColor: "white" }}
                    />
                  </div>
                  <div className="detail-box">
                    <label>Address</label>
                    <input
                      type="text"
                      className="profileInputBox addressBox"
                      disabled={true}
                      style={{ backgroundColor: "white" }}
                    />
                  </div>
                </div>
              </>
            )}

            {!isDetailsPage && (
              <>
                <div className="freeReports">
                  <p className="trials">
                    <span className="trailremaining">
                      {freeReportsRemaining}
                    </span>{" "}
                    of 2 remianng free trials{" "}
                  </p>
                </div>

                <div className="plan-cards">
                  <PlanCards
                    title="Basic"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="Free"
                    duration="Forever Free"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={false}
                  />
                  <PlanCards
                    title="Pro"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="$40"
                    duration="per month"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={true}
                    onClickFunction={handleUpgradeClick}
                  />

                  <PlanCards
                    title="Premium"
                    description="Get started with ease — list a couple of properties and explore our platform at no cost."
                    price="$90"
                    duration="per month"
                    features={[
                      "List up to 2 properties",
                      "Access to basic support",
                      "Visibility on search",
                      "Email notifications",
                    ]}
                    isHighlighted={false}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
};

// export default MyAccount;

export default connect(mapStateToProps)(MyAccount);
